import { useMutation } from "@apollo/client";
import { useCallback } from "react";

import { GqlPlannerV2FieldworkerMovePickupDropoffLocationInput } from "~/__generated__/graphql/types";

import { PlannerV2FieldworkerMovePickupDropoffLocationDocument } from "../mutations.generated";
import { PlannerV2TravelGroupGetTimelineDocument } from "../queries.generated";

export default function usePlannerV2FieldworkerMovePickupDropoffLocation(onSuccess: (plannerTravelGroupId: string) => void) {
    const [mutate, { data, loading, error }] = useMutation(PlannerV2FieldworkerMovePickupDropoffLocationDocument, {
        refetchQueries: [PlannerV2TravelGroupGetTimelineDocument],
        awaitRefetchQueries: true,
    });

    const moveFieldworker = useCallback(
        async (input: GqlPlannerV2FieldworkerMovePickupDropoffLocationInput) => {
            const response = await mutate({
                variables: { input },
            });
            const plannerTravelGroupId = response.data?.plannerV2FieldworkerMovePickupDropoffLocation?.id;
            if (plannerTravelGroupId) onSuccess(plannerTravelGroupId);
        },
        [mutate, onSuccess],
    );

    return {
        moveFieldworker,
        loading,
        error,
        data,
    };
}
